import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { THEME_CONFIG } from './theme-config';
import enCommon from '../locales/en/common.json';
import frCommon from '../locales/fr/common.json';
import itCommon from '../locales/it/common.json';
import deCommon from '../locales/de/common.json';

const SUPPORTED_LANGUAGES = ['en', 'fr', 'it', 'de'];
const STORAGE_KEY = 'i18nextLng';

const resources = {
  en: { common: enCommon },
  fr: { common: frCommon },
  it: { common: itCommon },
  de: { common: deCommon },
};

export function resolveInitialLanguage() {
  let lng = 'en';
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, 'en');
  }
  if (!lng || !SUPPORTED_LANGUAGES.includes(lng)) {
    lng = THEME_CONFIG.locale || 'en';
  }
  if (!SUPPORTED_LANGUAGES.includes(lng)) {
    lng = 'en';
  }
  return lng;
}

let initPromise;

/**
 * Bundled locale JSON (via src/locales) so production always matches the deployed JS.
 * Run `npm run locales:prepare` before dev/build to refresh from public/locales.
 */
export function initI18n() {
  if (i18n.isInitialized) {
    return Promise.resolve(i18n);
  }
  if (!initPromise) {
    initPromise = (async () => {
      const lng = resolveInitialLanguage();

      await i18n.use(initReactI18next).init({
        resources,
        lng,
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LANGUAGES,
        defaultNS: 'common',
        ns: ['common'],
        load: 'languageOnly',
        returnEmptyString: false,
        interpolation: { escapeValue: false },
      });

      return i18n;
    })();
  }
  return initPromise;
}

export default i18n;
